<template>
  <div class="logo-container">
    <transition>
      <!-- 展开情况下 -->
      <div v-if="!isCollapse" key="expand" class="sidebar-logo-link">
        <!-- 用户自定义Logo -->
        <a :href="logo_jump_url" v-if="logo" class="sidebar-logo2">
          <img v-if="logo" :src="logo" />
        </a>
        <!-- vhall Logo -->
        <a :href="logo_jump_url" v-else class="sidebar-logo2">
          <!-- 没有cms和datahub权限显示「微吼直播」log，否则显示「活动平台DEP」 -->
          <span v-if="permission['cms'] || permission['datahub']" class="logo_txt">
            {{ $t('ai.k_010001') }}
          </span>
          <img v-else src="../assets/images/sys/logo-red@2x.png" class="sidebar-logo static" />
        </a>
      </div>
    </transition>
    <!-- 是否收缩按钮 -->
    <div class="hamburger-container" :class="[{ 'is-collapse': isCollapse }]">
      <div class="hamburger" @click="toggleSideBar">
        <i class="vh-iconfont vh-icon_more"></i>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'LogoBar',
    data() {
      return {
        logo: '',
        logo_jump_url: ''
      };
    },
    computed: {
      isCollapse() {
        return this.$store.state.sidebar.isCollapse;
      },
      permission() {
        return this.$store.state.permissions || [];
      }
    },
    methods: {
      // 菜单栏折叠/展开
      toggleSideBar() {
        this.$store.commit('sidebar/setCollapse', !this.$store.state.sidebar.isCollapse);
      }
    },
    mounted() {
      // 从缓存中获取控制台图片
      let userInfo = this.$store.state.userInfo || {};
      this.logo = userInfo.user_extends ? userInfo.user_extends.logo : '';
      if (userInfo.user_extends?.extends_remark == 2) {
        this.logo = new URL('@/assets/images/qiniu_logo.png', import.meta.url).href; // 七牛云logo单独特殊处理
      }
      if (this.logo) {
        // 用户自定义
        this.logo_jump_url = userInfo.user_extends
          ? userInfo.user_extends.logo_jump_url
          : process.env.VUE_APP_COMPANY_URL;
      } else {
        // 使用微吼定义
        this.logo_jump_url = process.env.VUE_APP_COMPANY_URL;
      }
    }
  };
</script>
<style lang="less" scoped>
  .logo-container {
    width: 100% !important;
    height: 56px;
    background: #fff;
    text-align: center;
    overflow: hidden;
    border-bottom: 1px solid #f0f0f0;
    z-index: 10;
    position: relative;
    display: flex;
    flex-direction: row;

    .sidebar-logo-link {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      & .sidebar-logo {
        height: 44px;
        display: block;
      }

      a.sidebar-logo2 {
        text-align: left;
        display: flex !important;
        align-items: center;
        margin-left: 8px;
        height: 56px;

        img {
          height: 40px;
          max-width: 150px;
        }
      }

      .logo_txt {
        color: var(--theme-color);
        font-size: 22px;
        font-weight: 500;
      }
    }

    .hamburger-container {
      display: flex;
      position: relative;
      line-height: 56px;
      height: 56px;
      min-width: 64px;

      .hamburger {
        display: inline-block;
        width: 20px;
        height: 20px;
        padding: 0 15px;
        margin-top: 1px;
        margin-left: -1px;

        .vh-icon_more {
          color: var(--theme-color);
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
    .hamburger-container.is-collapse {
      margin-left: 16px;
    }
  }
</style>
